import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgStatementNoData(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.866 3.5L21.5262 18.5C21.9111 19.1667 21.43 20 20.6602 20H3.33968C2.56988 20 2.08875 19.1667 2.47366 18.5L11.1339 3.5C11.5188 2.83334 12.4811 2.83333 12.866 3.5ZM9.40186 2.5C10.5566 0.499999 13.4433 0.500001 14.598 2.5L23.2583 17.5C24.413 19.5 22.9696 22 20.6602 22H3.33968C1.03028 22 -0.413096 19.5 0.741605 17.5L9.40186 2.5ZM10.9999 9C10.9999 8.44772 11.4476 8 11.9999 8C12.5522 8 12.9999 8.44772 12.9999 9V14C12.9999 14.5523 12.5522 15 11.9999 15C11.4476 15 10.9999 14.5523 10.9999 14V9ZM10.9999 17C10.9999 16.4477 11.4476 16 11.9999 16C12.5522 16 12.9999 16.4477 12.9999 17C12.9999 17.5523 12.5522 18 11.9999 18C11.4476 18 10.9999 17.5523 10.9999 17Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementNoData);

var StatementNoDataSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { StatementNoDataSolid as default };
